import DeliveryCount from '@/generated/controls/delivery/DeliveryCount.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: DeliveryCount
})